/* eslint-disable max-lines-per-function */
import axios from "axios";
import { Message, MessageBox } from "element-ui";
import util from "@/common/utils";
import router from "../router/index";
import store from "../store";
import configs from "@/common/config";
// axios实列
// 全局配置
// axios.defaults.withCredentials = true;
const isProduct = process.env.NODE_ENV === "production";
const ajaxUrl = isProduct ? configs.apiUrl : configs.devApiUrl;
const ajax = axios.create({
  baseURL: ajaxUrl,
  timeout: 1000 * 60 * 5, //五分钟
});

let toastExist = false;

const CancelToken = axios.CancelToken;
// 添加请求拦截器
ajax.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么

    let token = isProduct
      ? sessionStorage.getItem("dfx-token")
      : sessionStorage.getItem("dfx-token") || configs.defToken;
    if (token) {
      config.headers["token"] = token;
    }
    config.cancelToken = new CancelToken((c) => {
      // 回调回去取消方法
      if (config.params) {
        config.params.abort && config.params.abort(c);
      } else if (config.abort) {
        config.abort(c);
      }
    });
    if (config.params && config.params.abort) {
      delete config.params.abort;
    } else if (config.abort) {
      delete config.abort;
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
let messageBox;
// 添加响应拦截器
ajax.interceptors.response.use(
  (res) => {
    // 对响应数据做点什么
    const data = res.data;
    switch (data.code) {
      case 401:
        // 授权过期
        MessageBox.alert("登录已过期，请重新登录", "", {
          type: "warning",
          customClass: "token-expired-alert",
          confirmButtonText: "重新登录",
          beforeClose: () => {
            util.reLogin();
            return false;
          },
        });
        break;
      case 3001:
        // 当前无有效的授权店铺
        if (!messageBox) {
          (messageBox = MessageBox.confirm(data.msg, "提示", {
            confirmButtonText: "去添加店铺",
            showClose: false,
            showCancelButton: false,
            type: "warning",
          }).then(() => {
            messageBox = null;
            setTimeout(() => {
              router.push("/apply/personalManage/shopManage");
            }, 10);
          })).catch(() => {
            messageBox = null;
          });
          return Promise.reject(data);
        }
        // 路由切换存在messageBox 清除
        // 解决客户不关闭授权过期弹窗，点浏览器返回，下次再报错不弹窗
        router.beforeEach((to, from, next) => {
          if (to.fullPath !== from.fullPath && messageBox) {
            messageBox = null;
          }
          next();
        });
        break;
      case 7001:
        // 付费的版本提示
        store.commit("setPackageTips", {
          key: "package",
          msg: data.msg,
        });
        break;
      case 7002:
        // TEMU授权令牌权限不够
        MessageBox({
          title: "系统检测到您未获取TEMU全部权限，请到Temu后台赋予权限后重新再授权",
          message: '<img src="//oss.dianleida.net/1688-web/images/temu_permission.png" class="temubg" />',
          dangerouslyUseHTMLString: true,
          confirmButtonText: "前往TEMU半托管后台重新获取",
          showClose: false,
          showCancelButton: true,
          customClass: "temu-permission-message-box",
        }).then(() => {
          messageBox = null;
          setTimeout(() => {
            window.open('https://agentseller.temu.com/open/system-manage/client-manage', "_blank");
          }, 10);
        }).catch(() => {
          messageBox = null;
        });
        return Promise.reject(data);
      case 7003:
        // token过期
        MessageBox({
          title: "提示",
          message: data.msg,
          type: "warning",
          confirmButtonText: "去处理",
          showClose: false,
          showCancelButton: true,
        }).then(() => {
          messageBox = null;
          setTimeout(() => {
            router.push("/apply/personalManage/shopManage");
          }, 10);
        }).catch(() => {
          messageBox = null;
        });
        return Promise.reject(data);
      default:
        if (location.href.indexOf("updatePrompt") !== -1) {
          router.push("/");
        }
        return data;
    }
    return data;
  },
  (error) => {
    if (
      error.code === "ECONNABORTED" &&
      error.message.includes("timeout")
    ) {
      Message.error("网络请求超时");
    }
    if (error && error.response) {
      // const { response, message, config } = error;
      const logId = util.uuid();
      if (!toastExist) {
        toastExist = true;
        MessageBox({
          dangerouslyUseHTMLString: true,
          type: "warning",
          title: "网络异常",
          confirmButtonText: "返回重试",
          message: `网络请求超时，请返回重试，如有问题请右上角联系客服。`,
          callback() {
            toastExist = false;
          },
        });
      }
    }
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default ajax;
